import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Forgot from "../views/Forgot.vue";
import Employees from "../views/Employees.vue";
import Vehicles from "../views/Vehicles.vue";
import Customers from "../views/Customers.vue";
import Stores from "../views/Stores.vue";
import ExerciseSheets from "../views/ExerciseSheets.vue";
import Operations from "../views/Operations.vue";
import OperationsNew from "../views/OperationsNew.vue";
import OperationsDetails from "../views/OperationsDetails.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Home", component: Home },
  {
    path: "/password-reset(/confirm/)?:uid?/:token?",
    name: "Forgot",
    component: Forgot,
    props: true,
  },
  { path: "/employees", name: "Employees", component: Employees },
  { path: "/vehicles", name: "Vehicles", component: Vehicles },
  { path: "/customers", name: "Customers", component: Customers },
  { path: "/stores", name: "Stores", component: Stores },
  {
    path: "/exercise-sheets",
    name: "ExerciseSheets",
    component: ExerciseSheets,
  },
  { path: "/operations", name: "Operations", component: Operations },
  { path: "/operations/new", name: "OperationsNew", component: OperationsNew },
  {
    path: "/operations/:id/edit",
    name: "OperationsDetails",
    component: OperationsDetails,
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
